import { observable, makeObservable, action } from 'mobx';
import { getOrderDetail } from '@/api/Payment/order';
import { createRefund, getRefundDetail, getRefundReason } from '@/api/Payment/refund';
import Toast from '@/components/Toast';
import { getCorrespondLabel } from '@/utils/global';

// import _ from 'lodash';
class Refund {
    constructor() {
        makeObservable(this);
    }
    @observable state = {
        reason: [],
        good: { total_price: '60', template_id: 104 },
        orderDetail: {},
        refundDetail: {
            id: 2,
            refund_status: 1,
            refund_no: '服务单号',
            order_no: '订单号',
            biz_info: [
                {
                    total_price: '60'
                }
            ],
            refund_price: 60,
            reason_str: '质量太差',
            reason_detail: '什么质量',
            store_name: getCorrespondLabel('301') + '名称',
            create_time: '2024-05-26',
            user_phone: '787978978'
        }
    };
    @action setState = (data) => {
        this.state = Object.assign({}, this.state, data);
    };
    //查询退款原因下拉
    handleRefundReason = async () => {
        let data = [],
         res = await getRefundReason().catch((err) => console.log(err));
        if (res && res.success) {
            data = res.data;
        } else {
            data = [];
        }
        this.setState({
            refundDetail: data
        });
    };
    //创建退款
    handleCreateRefund = async (data) => {
        let res = await createRefund(data);
        if (res && res.success) {
            return res.data;
        }
        Toast.error(res.msg || '退款失败');
        return false;
    };

    //查询退款详情
    handleRefundDetail = async (id) => {
        let data = null,
         good = {},
         res = await getRefundDetail(id).catch((err) => console.log(err));
        console.log(res, '哈哈');
        if (res && res.success) {
            data = res.data;
            good = res.data.biz_info[0];
        } else {
            Toast.error(res?.msg || '查询详情失败');
            data = null;
            good = {};
        }
        this.setState({
            refundDetail: data,
            good: good
        });
    };
    //获取订单详情
    handleOrderDetail = async (id) => {
        let data = null,
         good = {},
         res = await getOrderDetail(id);
        if (res && res.success) {
            data = res.data;
            good = res.data.cart_info[0];
        } else {
            data = null;
            good = {};
        }
        this.setState({
            orderDetail: data,
            good
        });

        return false;
    };
}
export default new Refund();
